import { render, staticRenderFns } from "./PageGame.vue?vue&type=template&id=5bc1c2ce&scoped=true&"
import script from "./PageGame.vue?vue&type=script&lang=js&"
export * from "./PageGame.vue?vue&type=script&lang=js&"
import style0 from "./PageGame.vue?vue&type=style&index=0&id=5bc1c2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1c2ce",
  null
  
)

export default component.exports